import React, { useRef } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Affix, Form } from "antd";
import { useNavigate } from "react-router-dom";
import SubmissionRealizationForm from "./SubmissionRealizationForm";

export default function CreateSubmissionRealization(props) {
  //   Refs
  const propertyFormRef = useRef(null);

  //   Antd
  const [form] = Form.useForm();

  //   Router
  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/export/submission-realization");
  };

  const addIou = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
        >
          <Header
            title="Add Export Submission & Realization"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() => discartForm()}
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  onClick={() => addIou()}
                >
                  Save
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>
      <SubmissionRealizationForm
        ref={propertyFormRef}
        form={form}
      />
    </>
  );
}
